import { render, staticRenderFns } from "./D4.vue?vue&type=template&id=2ba4d4aa&scoped=true"
import script from "./D4.vue?vue&type=script&lang=js"
export * from "./D4.vue?vue&type=script&lang=js"
import style0 from "./D4.vue?vue&type=style&index=0&id=2ba4d4aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba4d4aa",
  null
  
)

export default component.exports